import React, { useState } from "react";
import axiosClient from "../../axios";
import { useNavigate } from "react-router-dom";

const AddReview = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    what_they_said: "",
    image: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("what_they_said", form.what_they_said);
    if (form.image) formData.append("image", form.image);

    try {
      await axiosClient.post("/api/customer-says", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      navigate("/xl-admin/customer-reviews"); // redirect to review list
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to add review. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Add New Review</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">What They Said</label>
          <textarea
            name="what_they_said"
            className="form-control"
            value={form.what_they_said}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Image (optional)</label>
          <input
            type="file"
            name="image"
            className="form-control"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-success" disabled={loading}>
          {loading ? "Saving..." : "Add Review"}
        </button>
      </form>
    </div>
  );
};

export default AddReview;
